<div class="modal">
    <div class="modal__body modal__body">
        <i class="fal fa-times modal__close" (click)="close(null)" data-test-id="closeNoteDialogBtn"></i>
        <h1 class="h2">Add new file</h1>

        <app-file-selector [file]="file" (fileChange)="fileSelected($event)">
        </app-file-selector>

        <div class="flex mt-0100 flexJustify--between flexAlign--center">
            <mat-form-field class="mb-0 mr-0100 ab-input-group ab-input-group__field">
                <mat-label>Label (optional)</mat-label>
                <input type="text" matInput>
            </mat-form-field>

            <button type="button" class="btn" (click)="onSave()">Save</button>
        </div>
    </div>
</div>
